import { createHandbookResponseErrors } from '@/utils/error/responseErrors'
import { createNewHandbookApi } from '@/api/handbookApi'

export const TYPE_PACKAGING_URL = 'order/property/package-types'

const errors = createHandbookResponseErrors('вид упаковки', 'видов упаковки')

export const TypePackagingApi = createNewHandbookApi(TYPE_PACKAGING_URL, errors)
